import { render, staticRenderFns } from "./RolesModal.vue?vue&type=template&id=1854d459&scoped=true"
import script from "./RolesModal.vue?vue&type=script&lang=js"
export * from "./RolesModal.vue?vue&type=script&lang=js"
import style0 from "./RolesModal.vue?vue&type=style&index=0&id=1854d459&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854d459",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1854d459')) {
      api.createRecord('1854d459', component.options)
    } else {
      api.reload('1854d459', component.options)
    }
    module.hot.accept("./RolesModal.vue?vue&type=template&id=1854d459&scoped=true", function () {
      api.rerender('1854d459', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Roles/RolesModal.vue"
export default component.exports